import { render, staticRenderFns } from "./FavoriteList.vue?vue&type=template&id=006352ec&scoped=true&"
import script from "./FavoriteList.vue?vue&type=script&lang=js&"
export * from "./FavoriteList.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteList.vue?vue&type=style&index=0&id=006352ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006352ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VMain,VSpacer,VTextField})
